import { composeWithDevTools } from '@redux-devtools/extension';
import { applyMiddleware, compose, createStore } from 'redux';
import { thunk } from 'redux-thunk';
import { AppStore } from '../types/common';
import { addRehydrateStoreReducer } from '../utils/persist-store';
import createReducers from './reducers';

export default function configureStore({ initialState = {} }): AppStore {
  const functions = [composeWithDevTools(applyMiddleware(thunk))];
  return createStore(
    addRehydrateStoreReducer(createReducers()),
    initialState,
    compose(...functions),
  );
}
